"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  linkifyPlugin: true,
  linkElement: true,
  serializableLinkElement: true,
  withLink: true
};
Object.defineProperty(exports, "linkElement", {
  enumerable: true,
  get: function get() {
    return _element["default"];
  }
});
Object.defineProperty(exports, "linkifyPlugin", {
  enumerable: true,
  get: function get() {
    return _plugin["default"];
  }
});
Object.defineProperty(exports, "serializableLinkElement", {
  enumerable: true,
  get: function get() {
    return _serializableElement["default"];
  }
});
Object.defineProperty(exports, "withLink", {
  enumerable: true,
  get: function get() {
    return _withLink["default"];
  }
});
var _plugin = _interopRequireDefault(require("./plugin"));
var _element = _interopRequireDefault(require("./element"));
var _serializableElement = _interopRequireDefault(require("./serializableElement"));
var _withLink = _interopRequireDefault(require("./withLink"));
var _transforms = require("./transforms");
Object.keys(_transforms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _transforms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _transforms[key];
    }
  });
});